import { render, staticRenderFns } from "./welcomebusinesses.vue?vue&type=template&id=0bc021b2&scoped=true"
import script from "./welcomebusinesses.vue?vue&type=script&lang=js"
export * from "./welcomebusinesses.vue?vue&type=script&lang=js"
import style0 from "./welcomebusinesses.vue?vue&type=style&index=0&id=0bc021b2&prod&scoped=true&lang=css"
import style1 from "./welcomebusinesses.vue?vue&type=style&index=1&id=0bc021b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc021b2",
  null
  
)

export default component.exports